import { ContactSlugEnum } from '@systemeio/types'
import { defaultSearchFilterValue } from 'modules/contacts/constants/contact-default-filter'
import {
  ContactFilterDateConditionEnum,
  ContactFilterTagConditionEnum,
  ContactSearchFieldEnum,
} from 'modules/contacts/enums/contact-enum'
import { ContactFilterValueType } from 'modules/contacts/types/contact-filter-interface'
import { isStandardContactSlug } from 'modules/contacts/utils/is-standard-contact-slug'

export const getDefaultFilterValue = (slug: string): ContactFilterValueType[] => {
  if (isStandardContactSlug(slug)) {
    switch (slug) {
      case ContactSlugEnum.Country: {
        return [undefined]
      }
      default: {
        return [{ ...defaultSearchFilterValue }]
      }
    }
  } else if (Object.values(ContactSearchFieldEnum).includes(slug as ContactSearchFieldEnum)) {
    switch (slug) {
      case ContactSearchFieldEnum.tag: {
        return [{ searchValue: undefined, compareOperation: ContactFilterTagConditionEnum.in_list }]
      }
      case ContactSearchFieldEnum.created_at: {
        return [{ searchValue: null, compareOperation: ContactFilterDateConditionEnum.equals }]
      }
      case ContactSearchFieldEnum.removed_at: {
        return [{ searchValue: null, compareOperation: ContactFilterDateConditionEnum.equals }]
      }
      case ContactSearchFieldEnum.removed_reason_type: {
        return [{ searchValue: undefined }]
      }
      case ContactSearchFieldEnum.last_activity_date: {
        return [{ searchValue: null }]
      }
      case ContactSearchFieldEnum.state: {
        return [{ searchValue: undefined }]
      }
      case ContactSearchFieldEnum.affiliate: {
        return [{ searchValue: '' }]
      }
    }
  }
  return [{ ...defaultSearchFilterValue }]
}
